import { Handle, NodeProps, Position, Node } from "@xyflow/react";

type PromptNodeData = {
  label: string;
  prompt?: string;
  result?: string;
  webSearchNeeded?: boolean;
  isRoot?: boolean;
};

type FunctionNodeData = {
  label: string;
  result?: string;
};

export function PromptNodeUI({ data }: NodeProps<Node<PromptNodeData>>) {
  return (
    <div
      className={[
        "max-w-[460px]",
        "whitespace-pre-wrap",
        "relative",
        "rounded-2xl",
        "shadow-md",
        "px-4",
        "py-3",
        "break-words",
        "text-base",
        "mr-auto",
        "bg-gray-50",
        "border-l-[3px]",
        !data.isRoot ? "border-l-blue-500" : "border-l-green-500"
      ].join(" ")}
    >
      <Handle type="target" position={Position.Left} />
      <Handle type="source" position={Position.Right} />
      <Handle type="source" position={Position.Bottom} id="down" />
      <Handle type="target" position={Position.Top} id="up" />

      <div className="font-semibold mb-1 break-all">{String(data.label)}</div>
      {data.prompt && (
        <div className="opacity-80 overflow-hidden line-clamp-3">
          <strong>Prompt:</strong> {data.prompt}
        </div>
      )}
      {data.webSearchNeeded && (
        <div className="mt-1.5 text-[12px] opacity-65">
          <span role="img" aria-label="web search needed">
            🔎
          </span>{" "}
          web search needed
        </div>
      )}
    </div>
  );
}

export function FunctionNodeUI({ data }: NodeProps<Node<FunctionNodeData>>) {
  return (
    <div
      className={[
        "max-w-[460px]",
        "relative",
        "whitespace-pre-wrap",
        "rounded-2xl",
        "shadow-md",
        "px-4",
        "py-3",
        "break-words",
        "text-base",
        "mr-auto",
        "bg-gray-50",
        "border-l-[3px]",
        "border-l-purple-500"
      ].join(" ")}
      title={data.result ? `Result: ${data.result}` : undefined}
    >
      <Handle type="target" position={Position.Left} />
      <Handle type="source" position={Position.Right} />
      <Handle type="source" position={Position.Bottom} id="down" />
      <Handle type="target" position={Position.Top} id="up" />

      {String(data.label)}
    </div>
  );
}
